import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';

export const superAdminGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  if (adminAuth.isAdminAuthenticated() && adminAuth.isSuperAdmin()) {
    return true;
  }

  router.navigate(['/admin']);
  return false;
};
